var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeamlessMss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 299,
    viewBox: "0 0 414 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_6446_177554)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.0703,
    y: 10,
    width: 393,
    height: 279,
    rx: 16,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5703,
    y: 10.5,
    width: 392,
    height: 278,
    rx: 15.5,
    stroke: "#BFB5AD",
    strokeOpacity: 0.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.859 67.8323H63.375V265.936H341.859V67.8323Z",
    fill: "url(#paint0_linear_6446_177554)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.442 141.046H202.383V258.081H234.442V141.046Z",
    fill: "url(#paint1_linear_6446_177554)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287.532 166.591H231.312V258.08H287.532V166.591Z",
    fill: "url(#paint2_linear_6446_177554)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.805 266.469V178.82H131.793V108.503H193.244V180.894H223.289V265.936L100.805 266.469Z",
    fill: "url(#paint3_linear_6446_177554)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.355 264.872L125.891 260.5C122.45 258.909 120.248 255.462 120.248 251.67V201.819H113.584V251.67C113.584 255.462 111.382 258.909 107.941 260.5L98.4766 264.872H135.361H135.355Z",
    fill: "#1E3980"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.36,
    d: "M120.243 232.426V201.813H113.578V227.05C115.646 228.725 118.011 230.636 120.243 232.426Z",
    fill: "url(#paint4_linear_6446_177554)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.862 197.731L110.831 140.405C110.045 137.199 107.172 134.944 103.876 134.944H81.8565C78.4819 134.944 75.9963 138.106 76.8006 141.384L90.5349 197.501C91.6054 201.879 95.5303 204.964 100.042 204.964H139.364C141.36 204.964 142.98 203.343 142.98 201.347C142.98 199.351 141.36 197.731 139.364 197.731H124.862Z",
    fill: "#285EE0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.36,
    d: "M110.84 140.411C110.054 137.205 107.181 134.95 103.885 134.95H101.26L89.3281 192.536L90.5437 197.507C90.6768 198.045 90.8521 198.565 91.0638 199.055L130.87 201.813L129.739 197.731H124.87L110.84 140.405V140.411Z",
    fill: "url(#paint5_linear_6446_177554)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.687 192.929H141.476V200.543H96.2578V199.357C96.2578 195.807 99.1365 192.929 102.687 192.929Z",
    fill: "#1E3980"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.292 197.731C97.3809 197.731 95.7118 196.43 95.2582 194.568C92.3492 182.69 82.2315 141.384 82.2315 141.384C81.4271 138.106 83.9127 134.944 87.2873 134.944H81.8565C78.4819 134.944 75.9963 138.106 76.8006 141.384L90.5349 197.501C91.6054 201.879 95.5303 204.964 100.042 204.964H139.364C141.36 204.964 142.98 203.343 142.98 201.347C142.98 199.351 141.36 197.731 139.364 197.731H99.2859H99.292Z",
    fill: "#477DFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M307.809 192.227C307.809 192.227 301.538 191.58 306.418 180.894C309.382 174.405 312.768 170.818 318.175 172.663C323.588 174.507 320.37 187.189 320.37 187.189C320.37 187.189 325.202 187.552 323.104 194.822C329.2 201.438 325.565 220.488 314.692 220.488C303.219 220.488 304.271 208.072 306.902 205.538C301.61 204.014 305.547 194.029 307.803 192.227H307.809Z",
    fill: "#2CB86D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M314.727 180.894V257.47",
    stroke: "#223B52",
    strokeWidth: 0.483815,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M312.43 183.615L314.704 187.619",
    stroke: "#223B52",
    strokeWidth: 0.483815,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M318.181 187.982L314.703 195.62",
    stroke: "#223B52",
    strokeWidth: 0.483815,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M309.383 198.136L314.868 205.889",
    stroke: "#223B52",
    strokeWidth: 0.483815,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.13 199.563L314.703 211.501",
    stroke: "#223B52",
    strokeWidth: 0.483815,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M330.817 207.667C330.817 207.667 324.546 207.02 329.426 196.334C332.389 189.844 335.776 186.258 341.183 188.103C346.595 189.947 343.378 202.629 343.378 202.629C343.378 202.629 348.21 202.992 346.112 210.261C352.208 216.878 348.573 235.928 337.699 235.928C326.227 235.928 327.279 223.512 329.91 220.978C324.618 219.454 328.555 209.469 330.811 207.667H330.817Z",
    fill: "#2CB86D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M337.734 196.334V261.147",
    stroke: "#223B52",
    strokeWidth: 0.483815,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M335.438 199.049L337.705 203.059",
    stroke: "#223B52",
    strokeWidth: 0.483815,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M341.181 203.416L337.703 211.06",
    stroke: "#223B52",
    strokeWidth: 0.483815,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M332.391 213.576L337.876 221.323",
    stroke: "#223B52",
    strokeWidth: 0.483815,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M345.13 214.997L337.703 226.941",
    stroke: "#223B52",
    strokeWidth: 0.483815,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M143.977 265.937H351.406C351.406 265.937 350.033 245.804 333.1 245.066C323.49 227.395 309.49 226.252 296.584 230.6C288.02 216.642 275.344 212.408 263.146 215.553C255.296 201.994 217.74 186.784 203.909 229.058C185.73 230.37 180.982 241.123 179.47 246.844C170.859 251.876 171.028 255.541 164.654 257.373C158.279 259.205 146.148 255.746 143.977 265.943V265.937Z",
    fill: "#2CB86D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M181.665 166.591H142.367V168.817H181.665V166.591Z",
    fill: "#F9BA39"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M181.665 166.591H142.367V168.817H181.665V166.591Z",
    fill: "url(#paint6_linear_6446_177554)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M208.421 168.817H167.805L173.242 135.863H213.858L208.421 168.817Z",
    fill: "#DF9D2F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M170.242 168.817H167.805L173.242 135.863H175.673L170.242 168.817Z",
    fill: "#F9BA39"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M196.256 152.343C195.784 155.215 192.966 157.544 189.966 157.544C186.966 157.544 184.916 155.215 185.388 152.343C185.86 149.47 188.678 147.142 191.677 147.142C194.677 147.142 196.727 149.47 196.256 152.343Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M175.191 138.784L170.305 168.381",
    stroke: "#F9E5BD",
    strokeWidth: 0.344718,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M144.599 104.705C143.063 105.83 141.375 109.507 141.859 113.081C142.162 115.313 143.317 116.468 141.557 119.474C139.797 122.479 138.739 123.163 139.44 125.05C140.142 126.936 128.125 122.903 128.125 122.903L134.433 104.699H144.593L144.599 104.705Z",
    fill: "#12255E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M131.947 245.356L126.728 258.328C126.444 259.042 126.583 259.852 127.091 260.427C127.962 261.413 129.431 262.822 131.004 263.203C132.788 263.632 135.146 264.328 136.465 265.259C136.991 265.634 136.719 266.463 136.072 266.463H121.503C120.463 266.463 119.719 265.465 120.021 264.467C120.384 263.251 120.88 261.618 121.4 259.937C122.428 256.593 125.434 245.35 125.434 245.35H131.953L131.947 245.356Z",
    fill: "#FF8282"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M131.948 245.356H125.428C125.428 245.356 125.084 246.638 124.594 248.459L129.892 250.466L131.948 245.356Z",
    fill: "#D94D4D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M136.461 265.259C135.142 264.328 132.784 263.632 131 263.203C129.687 262.888 128.454 261.854 127.571 260.953L124.136 263.161L120.761 261.987C120.483 262.907 120.223 263.759 120.011 264.467C119.715 265.459 120.459 266.463 121.493 266.463H136.062C136.709 266.463 136.981 265.628 136.455 265.259H136.461Z",
    fill: "#222F73"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M167.989 234.319L170.232 245.876C170.232 245.876 173.819 254.627 173.655 255.601C173.492 256.575 169.307 254.113 168.678 252.511C168.049 250.908 168.049 248.561 166.392 246.85C164.735 245.132 162.727 242.901 165.158 241.758C164.33 239.067 162.328 234.319 162.328 234.319H167.989Z",
    fill: "#FF8282"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M168.673 252.511C169.302 254.113 173.487 256.569 173.651 255.601C173.784 254.821 171.492 249.003 170.585 246.759C170.294 247.164 169.853 247.4 169.187 247.303C166.514 246.929 165.154 241.752 165.154 241.752C162.723 242.895 164.724 245.126 166.387 246.844C168.044 248.561 168.044 250.908 168.673 252.504V252.511Z",
    fill: "#222F73"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M167.989 234.319H162.328C162.328 234.319 162.733 235.287 163.259 236.587L168.841 238.673L167.995 234.319H167.989Z",
    fill: "#D94D4D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M101.916 170.988C101.916 170.988 88.6173 187.952 104.662 193.183C108.75 194.513 141.849 194.096 141.849 194.096L161.244 235.831L170.57 235.631C170.57 235.631 162.677 190.897 161.075 183.918C159.472 176.939 153.182 174.308 143.796 174.308C134.41 174.308 118.511 172.137 118.511 172.137L101.922 170.994L101.916 170.988Z",
    fill: "url(#paint7_linear_6446_177554)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M151 183.918L148.43 190.957",
    stroke: "#B82A51",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M150.997 187.437L150.398 192.155",
    stroke: "#B82A51",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.36,
    d: "M121.992 176.364C129.291 175.911 133.21 174.834 135.284 173.921C127.029 173.298 118.502 172.131 118.502 172.131L101.913 170.988C101.913 170.988 94.5411 180.392 97.4016 187.359C100.964 177.519 109.056 177.168 121.992 176.364Z",
    fill: "url(#paint8_linear_6446_177554)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M160.078 233.345H170.226",
    stroke: "#B82A51",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M129.491 194.163C129.491 194.163 142.306 187.008 150.428 189.639C158.55 192.27 153.059 207.945 150.428 215.269C147.797 222.593 133.881 246.85 133.881 246.85H123.703L137.165 197.483C137.625 195.801 136.355 194.15 134.613 194.15L129.491 194.169V194.163Z",
    fill: "url(#paint9_linear_6446_177554)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.36,
    d: "M150.429 189.639C142.307 187.008 129.492 194.163 129.492 194.163L134.615 194.144C136.356 194.144 137.626 195.795 137.167 197.477L133.859 209.62C137.276 211.985 142.864 216.672 146.426 223.911C148.24 220.349 149.74 217.21 150.435 215.269C153.066 207.945 158.557 192.27 150.435 189.639H150.429Z",
    fill: "url(#paint10_linear_6446_177554)"
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M135.398 244.177H124.422",
    stroke: "#B82A51",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M144.475 192.155L139.195 197.731",
    stroke: "#B82A51",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M141.469 192.929L139.195 194.943",
    stroke: "#B82A51",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M135.323 122.933C135.323 122.933 138.728 122.449 141.673 125.781C144.001 128.418 149.396 153.195 149.396 153.195C149.396 153.195 159.52 128.884 160.439 127.112C161.352 125.34 162.042 124.197 163.644 123.048C165.247 121.905 165.876 120.471 166.39 120.762C166.904 121.046 164.503 123.163 165.362 123.453C166.221 123.737 168.682 121.506 168.682 121.506C168.682 121.506 169.885 118.99 170.454 119.558C171.028 120.133 170.339 124.995 164.334 126.882C162.562 133.347 158.873 168.817 148.749 168.817C138.625 168.817 133.672 138.155 133.672 138.155L135.329 122.939L135.323 122.933Z",
    fill: "#FF8282"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M152.063 167.438C149.033 163.138 143.475 162.007 140.766 161.711C142.925 165.823 145.586 168.811 148.743 168.811C149.934 168.811 151.035 168.315 152.057 167.432L152.063 167.438Z",
    fill: "#D94D4D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M141.679 125.781C138.734 122.449 135.329 122.933 135.329 122.933L133.672 138.149C133.672 138.149 135.202 147.632 138.304 156.044C139.048 154.677 140.179 153.335 141.909 152.331C144.86 150.625 146.523 147.305 147.43 144.602C145.652 137.175 143.1 127.378 141.685 125.769L141.679 125.781Z",
    fill: "#D94D4D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M149.394 153.195L147.906 157.205",
    stroke: "#D94D4D",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M166.243 124.251C166.243 124.251 163.122 123.477 162.469 126.223",
    stroke: "#D94D4D",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M139.444 107.033C139.444 107.033 138.072 111.781 138.87 112.755C138.18 113.383 137.497 113.444 137.497 113.444C137.497 113.444 136.366 117.562 135.779 117.962C135.024 118.482 132.344 117.333 132.344 117.333L130.917 122.195L124.797 120.707L126.4 112.7C126.4 112.7 122.856 104.693 127.603 101.832C132.35 98.9718 138.87 103.09 139.444 107.039V107.033Z",
    fill: "#FF8282"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M124.796 119.22C124.796 119.22 126.453 120.248 128.43 120.592C130.402 120.937 131.908 120.508 132.289 120.937C132.67 121.366 132.289 122.195 132.289 122.195L135.089 122.54C135.797 122.624 136.323 123.223 136.317 123.937C136.299 125.66 137.435 128.352 138.409 131.75C139.824 136.685 142.528 141.989 137.393 147.408L132.718 173.963C132.718 173.963 116.589 176.794 100.714 171.949C98.1799 171.175 100.714 170.232 102.087 168.817C103.46 167.401 114.618 127.971 114.618 127.971L117 120.671L124.802 119.22H124.796Z",
    fill: "#961313"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.36,
    d: "M130.863 174.223C124.525 167.317 130.573 149.343 125.941 145.817C115.871 138.149 116.905 130.946 116.905 130.946L113.18 133.02C110.12 143.707 103.159 167.716 102.095 168.817C100.722 170.232 98.1877 171.175 100.722 171.949C113.386 175.814 126.201 174.798 130.876 174.229L130.863 174.223Z",
    fill: "url(#paint11_linear_6446_177554)"
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M119.624 120.181C119.624 120.181 123.204 124.021 120.973 132.434C118.741 140.846 114.707 157.544 114.707 157.544L140.996 164.874C140.996 164.874 147.062 162.987 151.519 168.823H106.325C100.888 168.823 98.9469 165.732 101.463 154.919C103.979 144.106 107.825 131.236 109.506 127.003C111.187 122.77 114.223 120.768 119.624 120.187V120.181Z",
    fill: "#FF8282"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M114.693 157.538L108.688 156.05",
    stroke: "#D94D4D",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M139.443 106.888C139.443 106.888 137.308 108.31 133.879 107.366C132.827 107.076 131.744 107.59 131.297 108.582C130.674 109.961 129.628 111.14 128.793 111.932C128.043 112.652 127.638 113.65 127.656 114.69C127.692 116.752 127.33 120.096 124.802 121.197C121.052 122.83 120.411 119.951 115.779 121.627C111.146 123.302 109.816 125.787 109.816 125.787C109.816 125.787 108.358 120.979 111.787 117.423C115.222 113.861 117.708 113.474 119.637 108.285C121.566 103.096 122.77 97.9438 127.959 98.3308C133.148 98.7179 136.583 100.435 140.018 100.478C143.453 100.52 145.098 101.705 144.995 104.04C144.85 107.215 139.443 106.9 139.443 106.9V106.888Z",
    fill: "#222F73"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M132.345 117.327C130.857 116.752 128.166 114.781 127.852 113.293C127.966 116.099 129.617 119.274 131.553 120.018L132.345 117.327Z",
    fill: "#D94D4D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7857 265.936H55.558C52.0745 265.936 49.1414 263.336 48.7302 259.877L44.9141 228.029H84.4297L80.6136 259.877C80.2023 263.336 77.2692 265.936 73.7857 265.936Z",
    fill: "#3A4C59"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M81.0154 256.599L84.4384 228.029H57.5625C58.9293 231.295 61.3665 235.813 65.4789 239.925C72.2584 246.705 73.6312 259.998 81.0154 256.599Z",
    fill: "url(#paint12_linear_6446_177554)"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6172 231.961H82.7279",
    stroke: "#66869E",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7928 214.864C68.7928 214.864 68.2606 213.455 69.1375 209.947C70.0144 206.439 71.6896 205.647 72.8024 204.129C73.9152 202.617 73.6007 199.986 75.4332 198.154C77.2656 196.322 79.4186 196.055 80.3741 194.036C81.3297 192.016 83.2831 188.98 85.3332 188.435C86.6698 191.35 86.5488 193.933 85.3332 196.721C84.1176 199.509 84.1963 203.095 82.2852 205.804C80.3741 208.514 79.3339 207.709 77.4652 210.739C75.5965 213.769 72.7359 215.396 68.7989 214.858L68.7928 214.864Z",
    fill: "#2CB86D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M70.15 223.875C70.15 223.875 70.023 221.105 72.0913 219.829C74.1596 218.553 73.9237 216.642 76.2339 215.45C78.5441 214.259 78.6228 212.662 81.3321 211.628C84.0415 210.594 85.7953 208.52 87.7064 208.598C88.8192 211.785 86.7509 212.42 85.7167 214.416C84.6826 216.406 84.5495 217.924 82.7412 218.601C80.933 219.279 80.9874 220.869 79.0884 222.067C77.1895 223.264 75.1393 225.302 70.15 223.881V223.875Z",
    fill: "#2CB86D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4985 221.516C59.4985 221.516 60.1698 217.41 58.4704 215.759C56.771 214.108 55.2288 213.37 54.5394 211.507C53.85 209.645 53.1061 207.365 51.195 206.621C49.284 205.877 48.5401 204.026 47.6874 201.686C46.8347 199.345 42.1114 196.213 40.5692 195.735C39.7709 200.144 40.2003 203.5 41.6336 205.218C43.0669 206.935 42.9641 206.355 43.968 209.33C44.978 212.306 45.1353 213.842 47.1552 215.015C49.1751 216.182 50.0762 217.349 50.8745 219.158C51.6728 220.966 54.9507 222.81 59.4985 221.516Z",
    fill: "#2CB86D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1683 201.704C57.1683 201.704 58.9766 198.16 57.1683 194.737C55.36 191.314 54.4045 190.516 53.6848 186.929C52.9652 183.343 51.0541 181.196 49.3849 179.279C47.7158 177.362 48.5866 169.482 42.3757 167.649C37.6766 175.136 41.2629 177.314 42.0551 179.811C42.8534 182.309 42.2124 185.811 43.7303 189.639C45.2423 193.461 46.8389 192.191 47.5525 195.293C48.2722 198.402 52.4451 202.938 57.1683 201.704Z",
    fill: "#2CB86D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6284 153.195C59.6284 153.195 59.4953 156.014 57.9713 159.413C56.4473 162.811 56.3384 165.043 57.5117 168.23C58.6789 171.417 56.6287 173.752 57.9713 178.426C59.3139 183.101 60.3783 183.682 60.0577 188.435C59.7372 193.189 62.1261 197.519 64.7568 200.773C71.4214 194.253 70.2541 189.155 69.1898 183.525C68.1254 177.894 69.5103 174.175 68.0225 170.25C66.5348 166.319 65.3676 166.428 65.3676 163.132C65.3676 159.836 63.5473 154.199 59.6223 153.195H59.6284Z",
    fill: "#2CB86D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4766 158.675C60.4766 158.675 65.8953 182.89 64.6737 229.414",
    stroke: "#1D262D",
    strokeWidth: 0.514054,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7266 172.584C43.7266 172.584 48.3047 196.539 64.8572 209.336",
    stroke: "#1D262D",
    strokeWidth: 0.514054,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7143 193.298C83.7143 193.298 76.4631 209.336 64.8516 218.311",
    stroke: "#1D262D",
    strokeWidth: 0.514054,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7266 200.773C43.7266 200.773 51.6672 220.313 64.6758 223.875",
    stroke: "#1D262D",
    strokeWidth: 0.514054,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3321 211.223C85.3321 211.223 77.9841 222.054 64.7578 225.961",
    stroke: "#1D262D",
    strokeWidth: 0.514054,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5312 197.229C71.5312 197.229 69.5657 204.238 64.7578 207.056",
    stroke: "#1D262D",
    strokeWidth: 0.514054,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2266 207.056C56.2266 207.056 57.8594 212.263 64.8506 215.45",
    stroke: "#1D262D",
    strokeWidth: 0.514054,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6635 207.346C57.6635 208.036 57.1071 208.592 56.4177 208.592C55.7283 208.592 55.1719 208.036 55.1719 207.346C55.1719 206.657 55.7283 206.101 56.4177 206.101C57.1071 206.101 57.6635 206.657 57.6635 207.346Z",
    fill: "#163173"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7807 197.229C72.7807 197.918 72.2243 198.474 71.5349 198.474C70.8454 198.474 70.2891 197.918 70.2891 197.229C70.2891 196.539 70.8454 195.983 71.5349 195.983C72.2243 195.983 72.7807 196.539 72.7807 197.229Z",
    fill: "#163173"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M179.686 97.2301H157.267C156.481 97.2301 155.84 97.8651 155.84 98.6574V103.653L150.391 105.927L155.84 108.201V113.196C155.84 113.982 156.475 114.623 157.267 114.623H179.686C180.472 114.623 181.113 113.988 181.113 113.196V98.6574C181.113 97.8712 180.478 97.2301 179.686 97.2301Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M180.686 98.6089H158.267C157.481 98.6089 156.84 99.244 156.84 100.036V105.038L151.391 107.312L156.84 109.586V114.587C156.84 115.373 157.475 116.014 158.267 116.014H180.686C181.472 116.014 182.113 115.379 182.113 114.587V100.048C182.113 99.2621 181.478 98.621 180.686 98.621V98.6089Z",
    fill: "url(#paint13_linear_6446_177554)"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M162.039 105.836C162.039 106.429 161.562 106.906 160.969 106.906C160.376 106.906 159.898 106.429 159.898 105.836C159.898 105.243 160.376 104.766 160.969 104.766C161.562 104.766 162.039 105.243 162.039 105.836Z",
    fill: "#285EE0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M166.75 105.836C166.75 106.429 166.272 106.906 165.68 106.906C165.087 106.906 164.609 106.429 164.609 105.836C164.609 105.243 165.087 104.766 165.68 104.766C166.272 104.766 166.75 105.243 166.75 105.836Z",
    fill: "#285EE0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M171.438 105.836C171.438 106.429 170.96 106.906 170.367 106.906C169.775 106.906 169.297 106.429 169.297 105.836C169.297 105.243 169.775 104.766 170.367 104.766C170.96 104.766 171.438 105.243 171.438 105.836Z",
    fill: "#285EE0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M176.149 105.836C176.149 106.429 175.671 106.906 175.078 106.906C174.486 106.906 174.008 106.429 174.008 105.836C174.008 105.243 174.486 104.766 175.078 104.766C175.671 104.766 176.149 105.243 176.149 105.836Z",
    fill: "#285EE0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M250.083 70.7715L240.867 70.324C237.014 62.9639 228.342 59.172 220.129 61.7363C210.882 64.615 205.724 74.4485 208.602 83.6954C211.481 92.9423 221.315 98.101 230.561 95.2223C238.774 92.6641 243.758 84.6207 242.754 76.3717L250.089 70.7715H250.083Z",
    fill: "url(#paint14_linear_6446_177554)"
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M249.646 69.3563L240.429 68.9088C236.577 61.5488 227.904 57.7569 219.692 60.3211C210.445 63.1998 205.286 73.0333 208.165 82.2802C211.043 91.5272 220.877 96.6858 230.124 93.8071C238.337 91.249 243.32 83.2055 242.316 74.9565L249.652 69.3563H249.646Z",
    fill: "#DF9D2F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M223.093 70.5356L222.954 70.0397C222.796 69.4712 222.276 69.0781 221.683 69.0781H215.352V83.774H235.273V70.5356H223.093Z",
    fill: "url(#paint15_linear_6446_177554)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M234.359 71.0195H216.258V75.5976H234.359V71.0195Z",
    fill: "url(#paint16_linear_6446_177554)"
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M234.107 71.3581H216.508V75.6036H234.107V71.3581Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M234.107 73.0031H216.508V75.5976H234.107V73.0031Z",
    fill: "url(#paint17_linear_6446_177554)"
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M227.532 73.5414L227.671 73.0454C227.828 72.477 228.348 72.0839 228.941 72.0839H235.273V83.774H215.352V73.5474H227.532V73.5414Z",
    fill: "#F9D384"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M317.226 65.8245C325.293 60.8472 325.638 48.3164 313.966 43.944C302.294 39.5654 267.018 43.9561 250.381 44.5427C239.725 44.9237 222.356 43.9319 220.378 33.4815C218.4 23.025 229.764 19.6504 236.84 23.6056C243.922 27.5547 242.591 40.5089 232.232 45.6675C221.207 51.1588 199.701 63.6836 163.258 50.6387C126.814 37.5939 98.239 27.4761 76.1528 43.7746C56.6188 58.1923 57.4473 80.2482 66.5733 90.8015C79.7875 106.078 106.561 102.643 113.939 86.1689",
    stroke: "#285EE0",
    strokeWidth: 0.453577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M306.195 259.199C306.195 259.199 307.586 261.715 307.519 265.834H301.962C301.962 265.834 295.666 266.063 289.836 265.834C289.836 265.834 290.749 263.886 294.124 263.433C297.498 262.973 300.014 259.774 300.014 259.774L306.195 259.199Z",
    fill: "#59301E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M265.265 259.199C265.265 259.199 266.656 261.715 266.59 265.834H261.032C261.032 265.834 254.736 266.063 248.906 265.834C248.906 265.834 249.819 263.886 253.194 263.433C256.569 262.973 259.085 259.774 259.085 259.774L265.265 259.199Z",
    fill: "#59301E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M273.935 171.562L269.405 212.922C269.405 212.922 270.27 231.114 266.605 250.509C266.605 250.509 267.603 252.311 266.605 254.627C266.726 257.028 266.605 260.463 266.605 260.463H255.568L257.37 255.915C257.37 255.915 253.85 215.668 253.336 204.861C252.871 195.082 251.982 167.752 252.266 152.331C252.32 149.494 253.391 146.773 255.29 144.662L256.711 143.084L272.133 143.676L273.935 171.562Z",
    fill: "#1C3170"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M273.276 161.378C273.276 161.378 265.765 176.546 252.75 188.895C252.95 195.566 253.173 201.341 253.343 204.855C253.56 209.421 254.316 219.236 255.109 229.058C258.114 227.497 261.047 225.677 262.178 224.074C265.166 223.185 267.597 220.93 269.49 218.353C269.496 214.948 269.399 212.922 269.399 212.922L273.929 171.562L273.27 161.378H273.276Z",
    fill: "url(#paint18_linear_6446_177554)"
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M265.117 144.729L265.643 154.465C265.746 156.31 266.641 158.022 268.105 159.152L268.83 159.715",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M255.399 149.21C255.399 149.21 256.106 154.913 252.75 159.031",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M294.173 141.427C294.173 141.427 298.122 197.646 298.128 206.911C298.128 206.911 304.599 225.562 305.748 247.987C305.748 247.987 306.891 249.13 305.748 252.565C305.748 252.565 307.835 254.452 307.496 260.457H297.197C297.197 260.457 298.485 257.712 297.711 254.621C296.937 251.531 281.062 211.544 281.062 211.544L269.408 167.553L267.539 141.427H294.167H294.173Z",
    fill: "#1E3980"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M267.648 144.396L269.511 167.97",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M294.166 141.427H267.538L267.689 143.501L256.718 143.078L255.297 144.656C253.398 146.767 252.322 149.488 252.273 152.325C252.273 152.446 252.273 152.579 252.273 152.7L270.743 155.996C270.743 155.996 285.814 162.34 295.744 164.493C294.91 151.865 294.178 141.421 294.178 141.421L294.166 141.427Z",
    fill: "url(#paint19_linear_6446_177554)"
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M294.164 141.427H255.398V144.729H294.164V141.427Z",
    fill: "#613B0C",
    stroke: "#1D262D",
    strokeWidth: 0.169335,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M270.247 141.427H262.18V144.729H270.247V141.427Z",
    fill: "#1D262D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M199.224 106.495C199.224 106.495 194.845 104.518 194.507 104.971C194.162 105.431 198.111 107.801 198.111 107.801L197.881 108.316C197.881 108.316 192.898 107.1 192.735 107.626C192.39 108.715 197.742 109.428 197.742 109.428L197.627 111.031C197.627 111.031 193.654 114.69 194.337 114.98C195.027 115.264 197.397 112.718 197.397 112.718C197.397 112.718 194.936 115.978 195.281 116.323C195.626 116.667 198.686 113.347 198.686 113.347L199.23 106.489L199.224 106.495Z",
    fill: "#FF8282"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M208.524 101.781L198.602 100.469L196.03 119.925L205.952 121.236L208.524 101.781Z",
    fill: "#1C3170"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M205.949 121.233L206.891 121.357L209.462 101.902L208.521 101.777L205.949 121.233Z",
    fill: "#0D1A42"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M207.55 102.623L199.312 101.534L196.994 119.077L205.231 120.166L207.55 102.623Z",
    fill: "#78BBFF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M207.55 102.623L199.312 101.534L196.994 119.077L205.231 120.166L207.55 102.623Z",
    fill: "url(#paint20_linear_6446_177554)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M204.473 110.251L202.889 106.247L200.312 109.7L201.462 109.852L200.954 113.686L202.816 113.934L203.324 110.1L204.473 110.251Z",
    fill: "url(#paint21_linear_6446_177554)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M215.63 115.482L212.243 113.898L211.124 110.456C210.683 109.096 209.661 108.001 208.33 107.469C206.812 106.858 205.022 106.229 204.95 106.616C204.823 107.293 207.526 108.92 207.526 108.92L208.119 112.144L207.399 117.587H210.29L215.188 120.459L215.63 115.482Z",
    fill: "#FF8282"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M256.172 141.427H294.17L285.606 77.7687L277.883 75.5854L266.985 77.557L260.121 81.3731L256.172 141.427Z",
    fill: "#285EE0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M273.289 69.4894C273.289 69.4894 273.591 67.1308 275.351 65.758C277.111 64.3852 277.541 59.2809 274.105 57.8658C274.837 53.7896 273.035 52.9309 270.096 53.0155C267.157 53.1002 265.227 55.5011 262.306 55.5011C259.385 55.5011 257.928 55.4588 257.801 57.5634C257.686 59.4442 258.315 62.97 263.982 62.3713C268.699 65.6733 270.888 70.1789 273.289 69.4955V69.4894Z",
    fill: "#1D262D"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M264.371 58.6035L268.006 57.0916C268.006 57.0916 268.435 59.1539 270.491 59.8796V65.2862C270.491 65.2862 271.223 64.2581 271.435 63.3147C272.378 62.1535 273.152 62.6736 273.019 63.7864C272.892 64.8992 272.288 66.8344 271.09 66.8768C272.034 68.5097 273.279 69.4954 273.279 69.4954L274.652 74.6843L277.87 75.5854C277.87 75.5854 275.898 81.0767 271.604 81.0767C267.31 81.0767 266.972 77.557 266.972 77.557L267.613 77.1276L266.627 71.0799L265.399 71.1767C264.583 71.2432 263.881 70.5961 263.881 69.7736V66.0603L262.297 65.9757L263.035 60.3574C263.138 59.5772 263.646 58.912 264.371 58.6096V58.6035Z",
    fill: "#FF8282"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M266.641 71.0799C268.183 70.8501 270.644 69.0539 271.134 68.3645C271.104 70.082 268.485 72.4769 266.949 72.9668L266.641 71.0799Z",
    fill: "#D94D4D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M279.845 75.9786L296.21 79.2504C299.137 79.837 301.223 82.4436 301.151 85.4251L299.56 150.855L278.871 152.095C277.607 152.173 276.482 151.315 276.216 150.081L269.54 119.159C269.346 118.258 269.364 117.327 269.588 116.438L279.851 75.9846L279.845 75.9786Z",
    fill: "#1C3170"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.36,
    d: "M299.561 150.855L300.499 112.295L290.75 98.4518L288.476 127.801C288.313 129.894 287.914 131.956 287.279 133.952L281.594 151.931L299.555 150.855H299.561Z",
    fill: "url(#paint22_linear_6446_177554)"
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M277.885 112.755L276.228 103.145L285.203 87.4692L283.492 76.7043L279.851 75.9786L269.588 116.432C269.364 117.321 269.346 118.252 269.54 119.153L271.699 129.144L277.885 112.755Z",
    fill: "#263D82"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M284.461 98.7964C284.461 98.7964 285.126 104.221 291.144 106.374",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M295.503 144.729L289.812 157.344C289.812 157.344 291.052 159.431 294.046 161.378C294.989 160.435 295.104 157.489 295.104 157.489L302.083 148.563L295.503 144.729Z",
    fill: "#FF8282"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M294.172 147.867L298.073 153.691L302.082 148.563L295.502 144.729L294.172 147.867Z",
    fill: "#D94D4D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M283.209 131.181L282.461 131.851L290.025 140.299L290.773 139.629L283.209 131.181Z",
    fill: "#285EE0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M253.257 84.4635C248.28 87.1245 244.845 94.4422 240.987 102.582C237.128 110.723 233.179 117.756 233.179 117.756C233.179 117.756 232.066 116.299 231.722 117.756C231.377 119.214 231.207 119.818 231.207 119.818L214.988 114.853C214.988 114.853 212.502 118.96 211.812 123.767C211.812 123.767 227.143 139.165 237.467 139.558C246.478 139.903 253.814 115.815 253.814 115.815L253.257 84.4696V84.4635Z",
    fill: "#1C3170"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.36,
    d: "M253.263 84.4635C248.285 87.1245 244.85 94.4422 240.992 102.582C239.976 104.729 238.954 106.798 237.992 108.678C240.98 110.414 244.862 113.982 246.138 121.106C246.743 124.487 247.608 126.955 248.539 128.763C251.781 122.491 253.819 115.809 253.819 115.809L253.263 84.4635Z",
    fill: "url(#paint23_linear_6446_177554)"
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M248.703 99.3105C248.703 99.3105 250.675 106.35 254.364 112.011",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M233.953 119.353L237.418 123.368",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M232.812 121.36L233.23 124.644",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M218.562 115.948L214.988 114.853C214.988 114.853 212.502 118.96 211.812 123.767C211.812 123.767 212.968 124.929 214.854 126.616C215.985 122.824 217.63 118.391 218.562 115.948Z",
    fill: "#285EE0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M294.086 78.821C294.086 78.821 302.994 79.2322 308.032 88.842C311.654 95.7606 315.458 113.341 317.303 122.655C318.065 126.495 317.466 130.474 315.621 133.928L305.516 152.796L294.648 145.932L299.565 129.144C299.565 129.144 290.415 104.741 287.778 96.8491C285.147 88.9569 291.122 79.5588 294.086 78.821Z",
    fill: "url(#paint24_linear_6446_177554)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M295.965 141.427L294.641 145.932L305.514 152.796L307.643 148.823L295.965 141.427Z",
    fill: "#285EE0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M300.094 128.878C300.094 128.878 304.249 127.856 306.135 126.483",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M301.148 129.628H305.448",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M303.117 96.8189L307.744 98.4518",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M301.906 104.082C301.906 104.082 305.251 102.57 308.172 101.971",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M290.312 104.082C289.259 101.155 288.358 98.5969 287.772 96.8492C285.897 91.2308 288.382 84.8505 291.043 81.3731",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M286.523 152.101C286.523 152.101 288.41 158.53 295.589 162.303",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M265.609 77.7687L266.601 116.474C266.625 117.442 266.528 118.403 266.31 119.347L259.628 148.436C259.186 150.365 257.263 151.575 255.328 151.139L246.812 149.21L251.874 127.68L253.247 84.4635L265.603 77.7687H265.609Z",
    fill: "#1C3170"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M256.702 131.976L255.797 131.543L250.901 141.771L251.806 142.204L256.702 131.976Z",
    fill: "#285EE0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M266.602 116.474L265.61 77.7687L261.969 79.7402L258.57 89.8701L264.146 103.024L260.711 113.123L264.316 128.001L266.305 119.347C266.523 118.403 266.62 117.442 266.596 116.474H266.602Z",
    fill: "#263D82"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M292.934 208.29C292.934 208.29 291.331 211.949 291.102 213.781",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M295.323 211.036L292.922 214.35",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M263.345 209.318C263.345 209.318 261.808 213.322 259.867 216.412",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M264.783 213.781L261.602 217.325",
    stroke: "#285EE0",
    strokeWidth: 0.344718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0547 265.937H364",
    stroke: "#3D5413",
    strokeWidth: 0.713627,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M345.275 122.479V109.398H338.429V122.479C338.429 122.836 338.139 123.132 337.776 123.132H335.726C335.514 123.132 335.387 123.368 335.508 123.544L341.471 132.186C341.652 132.452 342.045 132.452 342.227 132.186L348.19 123.544C348.311 123.368 348.19 123.132 347.972 123.132H345.922C345.565 123.132 345.269 122.842 345.269 122.479H345.275Z",
    fill: "#285EE0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M337.205 133.353L336.915 132.313C336.582 131.121 335.5 130.305 334.266 130.305H321.016V161.039H362.678V133.353H337.205Z",
    fill: "url(#paint25_linear_6446_177554)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M360.774 134.363H322.922V143.937H360.774V134.363Z",
    fill: "url(#paint26_linear_6446_177554)"
  }), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M360.252 135.065H323.445V143.937H360.252V135.065Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M360.252 138.512H323.445V143.943H360.252V138.512Z",
    fill: "url(#paint27_linear_6446_177554)"
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M346.488 139.643L346.779 138.602C347.111 137.411 348.194 136.595 349.428 136.595H362.678V161.039H321.016V139.643H346.488Z",
    fill: "#DF9D2F"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M362.678 163.132H321.016V174.949H362.678V163.132Z",
    fill: "url(#paint28_linear_6446_177554)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M163.365 71.4307H159.64C159.64 71.3763 159.64 71.3279 159.64 71.2735C159.64 59.045 149.728 49.1329 137.499 49.1329C130.109 49.1329 123.571 52.7554 119.55 58.3193C118.231 57.8899 116.822 57.6541 115.359 57.6541C107.835 57.6541 101.739 63.7501 101.739 71.2735C101.739 71.3279 101.745 71.3763 101.745 71.4307H98.3707C93.3208 71.4307 89.2266 75.525 89.2266 80.5748C89.2266 85.6246 93.3208 89.7189 98.3707 89.7189H163.359C168.409 89.7189 172.503 85.6246 172.503 80.5748C172.503 75.525 168.409 71.4307 163.359 71.4307H163.365Z",
    fill: "url(#paint29_linear_6446_177554)"
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M163.365 69.4591H159.64C159.64 69.4047 159.64 69.3563 159.64 69.3019C159.64 57.0735 149.728 47.1613 137.499 47.1613C130.109 47.1613 123.571 50.7839 119.55 56.3478C118.231 55.9184 116.822 55.6825 115.359 55.6825C107.835 55.6825 101.739 61.7786 101.739 69.3019C101.739 69.3563 101.745 69.4047 101.745 69.4591H98.3707C93.3208 69.4591 89.2266 73.5534 89.2266 78.6032C89.2266 83.6531 93.3208 87.7474 98.3707 87.7474H163.359C168.409 87.7474 172.503 83.6531 172.503 78.6032C172.503 73.5534 168.409 69.4591 163.359 69.4591H163.365Z",
    fill: "#3C75FF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M125.8 68.6751V83.3989H135.561V68.6751H140.126L130.677 57.8947L121.234 68.6751H125.8Z",
    fill: "url(#paint30_linear_6446_177554)"
  }), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M125.867 69.5801V83.7136H135.888V69.5801H140.575L130.874 57.0312L121.18 69.5801H125.867Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M187.082 173.165L172.664 265.936H176.553L193.486 173.165H187.082Z",
    fill: "#3A4C59"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M230.434 173.165L244.846 265.936H240.957L224.023 173.165H230.434Z",
    fill: "#3A4C59"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M230.436 173.165H224.031L227.944 194.598C229.855 194.677 231.803 194.695 233.78 194.652L230.442 173.159L230.436 173.165Z",
    fill: "url(#paint31_linear_6446_177554)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M193.484 173.165H187.08L185.453 183.633C187.098 184.444 188.985 185.321 191.102 186.216L193.484 173.165Z",
    fill: "url(#paint32_linear_6446_177554)"
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M174.546 173.159H234.406V168.811H174.546V173.159Z",
    fill: "#3A4C59"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M174.556 168.817H122.383V173.165H174.556V168.817Z",
    fill: "#66869E"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M126.785 173.165L112.367 265.936H116.262L133.195 173.165H126.785Z",
    fill: "#66869E"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M170.147 173.165L184.564 265.936H180.676L163.742 173.165H170.147Z",
    fill: "#66869E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M170.139 173.165H163.734L167.647 194.598C169.558 194.677 171.506 194.695 173.483 194.652L170.145 173.159L170.139 173.165Z",
    fill: "url(#paint33_linear_6446_177554)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M133.195 173.165H126.791L125.164 183.633C126.809 184.444 128.696 185.321 130.813 186.216L133.195 173.165Z",
    fill: "url(#paint34_linear_6446_177554)"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M360.135 245.356C357.298 247.225 356.168 248.743 354.771 252.553C353.38 248.743 352.249 247.225 349.406 245.356C352.243 243.487 353.374 241.969 354.771 238.159C356.162 241.969 357.292 243.487 360.135 245.356Z",
    fill: "#FCB707"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M55.252 149.785C52.4157 151.653 51.2848 153.171 49.8877 156.981C48.4968 153.171 47.3659 151.653 44.5234 149.785C47.3598 147.916 48.4907 146.398 49.8877 142.588C51.2787 146.398 52.4096 147.916 55.252 149.785Z",
    fill: "#FCB707"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2641 109.404C58.3832 110.644 57.6393 111.648 56.7141 114.17C55.7948 111.648 55.0449 110.644 53.1641 109.404C55.0449 108.164 55.7888 107.16 56.7141 104.639C57.6333 107.16 58.3832 108.164 60.2641 109.404Z",
    fill: "#FCB707"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M353.373 92.7307C351.493 93.9704 350.749 94.9744 349.823 97.4962C348.898 94.9744 348.154 93.9704 346.273 92.7307C348.154 91.4909 348.898 90.487 349.823 87.9651C350.743 90.487 351.493 91.4909 353.373 92.7307Z",
    fill: "#FCB707"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M319.132 65.9091L316.719 56.1784L302.234 75.6217L326.322 72.8942L319.132 65.9091Z",
    fill: "url(#paint35_linear_6446_177554)"
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M318.052 65.0504L315.633 55.3196L301.148 74.763L318.052 65.0504Z",
    fill: "#F9A963"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M318.052 65.0504L325.242 72.0355L301.148 74.763L318.052 65.0504Z",
    fill: "#FFB87D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_6446_177554",
    x: 0.0703125,
    y: 0,
    width: 413,
    height: 299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6446_177554"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6446_177554",
    result: "effect2_dropShadow_6446_177554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6446_177554",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6446_177554",
    x1: 202.617,
    y1: 279.338,
    x2: 202.617,
    y2: 50.9713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FAFCFF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF3FF",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DBE6FF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C1D4FF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9FBDFF",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6446_177554",
    x1: 218.415,
    y1: 246.251,
    x2: 218.415,
    y2: 163.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FAFCFF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF3FF",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DBE6FF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C1D4FF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9FBDFF",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6446_177554",
    x1: 259.416,
    y1: 248.834,
    x2: 259.416,
    y2: 184.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FAFCFF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF3FF",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DBE6FF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C1D4FF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9FBDFF",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6446_177554",
    x1: 162.05,
    y1: 250.509,
    x2: 162.05,
    y2: 138.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FAFCFF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF3FF",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DBE6FF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C1D4FF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9FBDFF",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6446_177554",
    x1: 116.916,
    y1: 242.496,
    x2: 116.916,
    y2: 199.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6446_177554",
    x1: 102.052,
    y1: 207.534,
    x2: 119.899,
    y2: 157.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6446_177554",
    x1: 155.327,
    y1: 167.704,
    x2: 194.625,
    y2: 167.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6446_177554",
    x1: 96.7454,
    y1: 203.409,
    x2: 170.563,
    y2: 203.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D0E67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6446_177554",
    x1: 96.7424,
    y1: 179.176,
    x2: 135.29,
    y2: 179.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6446_177554",
    x1: 149.122,
    y1: 180.652,
    x2: 128.299,
    y2: 235.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D0E67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6446_177554",
    x1: 133.859,
    y1: 219.823,
    x2: 149.075,
    y2: 182.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6446_177554",
    x1: 116.113,
    y1: 168.907,
    x2: 122.633,
    y2: 140.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6446_177554",
    x1: 54.3996,
    y1: 242.586,
    x2: 113.389,
    y2: 242.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6446_177554",
    x1: 166.752,
    y1: 129.7,
    x2: 166.752,
    y2: 90.1543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6446_177554",
    x1: 238.67,
    y1: 107.154,
    x2: 228.59,
    y2: 74.7899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6446_177554",
    x1: 225.312,
    y1: 74.5694,
    x2: 225.312,
    y2: 65.9757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF3C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FF4D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF6A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FF9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB336"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6446_177554",
    x1: 225.305,
    y1: 67.4453,
    x2: 225.305,
    y2: 73.7954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6446_177554",
    x1: 225.307,
    y1: 74.2792,
    x2: 225.307,
    y2: 66.8042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6446_177554",
    x1: 253.379,
    y1: 206.343,
    x2: 287.192,
    y2: 175.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6446_177554",
    x1: 273.997,
    y1: 168.073,
    x2: 273.997,
    y2: 146.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6446_177554",
    x1: 202.362,
    y1: 110.11,
    x2: 200.245,
    y2: 127.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6446_177554",
    x1: 201.601,
    y1: 113.474,
    x2: 203.221,
    y2: 106.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6446_177554",
    x1: 281.594,
    y1: 125.189,
    x2: 300.499,
    y2: 125.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6446_177554",
    x1: 238.924,
    y1: 122.032,
    x2: 253.686,
    y2: 101.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6446_177554",
    x1: 291.987,
    y1: 82.1775,
    x2: 301.252,
    y2: 115.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#263D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#203678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C3170"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6446_177554",
    x1: 341.85,
    y1: 141.784,
    x2: 341.85,
    y2: 123.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF3C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FF4D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF6A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FF9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB336"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6446_177554",
    x1: 341.851,
    y1: 126.888,
    x2: 341.851,
    y2: 140.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6446_177554",
    x1: 341.854,
    y1: 141.185,
    x2: 341.854,
    y2: 125.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6446_177554",
    x1: 341.85,
    y1: 173.201,
    x2: 341.85,
    y2: 161.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FAFCFF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEF3FF",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DBE6FF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C1D4FF",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9FBDFF",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6446_177554",
    x1: 130.871,
    y1: 113.299,
    x2: 130.871,
    y2: 67.3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6446_177554",
    x1: 130.677,
    y1: 60.2482,
    x2: 130.677,
    y2: 81.3363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6446_177554",
    x1: 228.9,
    y1: 200.736,
    x2: 228.9,
    y2: 161.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6446_177554",
    x1: 189.469,
    y1: 200.736,
    x2: 189.469,
    y2: 161.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6446_177554",
    x1: 168.609,
    y1: 206.228,
    x2: 168.609,
    y2: 153.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6446_177554",
    x1: 129.174,
    y1: 206.228,
    x2: 129.174,
    y2: 153.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6446_177554",
    x1: 302.234,
    y1: 65.897,
    x2: 326.322,
    y2: 65.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlessMss);
export default __webpack_public_path__ + "static/media/seamless_MSS.7a616898dee2410c2281525a4e01c1f1.svg";
export { ForwardRef as ReactComponent };